import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

import ModalEditService from './EditService';
import Duplicate from './Duplicate';
import Delete from './Delete';
import ResetCustomRates from './ResetCustomRates';
import EditDescription from './EditDescription';
import EditCategory from './EditCategory';
import CategoryVisibility from './CategoryVisibility';
import MassAssignCategory from './MassAssignCategory';
import MassAssignCategoryConfirm from './MassAssignCategory/Confirm';
import MassDelete from './MassDelete';
import MassDisable from './MassDisable';
import MassEnable from './MassEnable';
import MassResetCustomRates from './MassResetCustomRates';
import DeleteCategory from './DeleteCategory';
import ImportServices from './ImportServices';
import ServiceStatus from './ServiceStatus';
import MassDripFeed from './MassDripFeed';

import { MODALS } from '../../constants';
import { closeModal } from '../../reducer';

const Modals = ({ modal, servicesCount, servicesList, serviceDispatch }) => {
  const onClose = () => {
    serviceDispatch(closeModal());
  };

  const modalsComponentsList = [
    {
      name: MODALS.EDIT_SERVICE,
      Component: ModalEditService,
      options: {},
    },
    {
      name: MODALS.DUPLICATE,
      Component: Duplicate,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.CHANGE_CATEGORY_VISIBILITY,
      Component: CategoryVisibility,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.DELETE,
      Component: Delete,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.RESET_CUSTOM_RATES,
      Component: ResetCustomRates,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.EDIT_DESCRIPTION,
      Component: EditDescription,
      options: {},
    },
    {
      name: MODALS.EDIT_CATEGORY,
      Component: EditCategory,
      options: {},
    },
    {
      name: MODALS.ASSIGN_CATEGORY,
      Component: MassAssignCategory,
      options: {},
    },
    {
      name: MODALS.ASSIGN_CATEGORY_CONFIRM,
      Component: MassAssignCategoryConfirm,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.DELETE_CATEGORY,
      Component: DeleteCategory,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.DELETE_ALL,
      Component: MassDelete,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.ENABLE_ALL,
      Component: MassEnable,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.DISABLE_ALL,
      Component: MassDisable,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.RESET_CUSTOM_RATES_ALL,
      Component: MassResetCustomRates,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.IMPORT_SERVICES,
      Component: ImportServices,
      options: {
        bsSize: 'large',
        className: 'modal-services',
      },
    },
    {
      name: MODALS.CHANGE_SERVICE_STATUS,
      Component: ServiceStatus,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      name: MODALS.CHANGE_DRIP_FEED_ALL,
      Component: MassDripFeed,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
  ]

  if (modalsComponentsList.length) {
    const modalData = modal?.data ? modal.data : null;
    return modalsComponentsList.map((item) => {
      const { Component, options, name } = item;
      const showModal = modal?.name === name;

      return (
        <Modal
          key={name}
          show={showModal}
          backdrop="static"
          onHide={onClose}
          {...options}
        >
          <Component
            onClose={onClose}
            modalData={modalData}
            servicesCount={servicesCount}
            servicesList={servicesList}
            serviceDispatch={serviceDispatch}
          />
        </Modal>
      )
    })
  }
  return null;
};

Modals.propTypes = {
  modal: PropTypes.object,
  servicesCount: PropTypes.number,
  servicesList: PropTypes.array,
  serviceDispatch: PropTypes.func,
}

const arePropsEqual = (prevProps, nextProps) => _.isEqual(prevProps.modal, nextProps.modal)
export default memo(Modals, arePropsEqual)
